import Vue from "vue";
import Router from "vue-router";
import store from "@/store/index";
const firebase = require("./firebase/config.js");

import HomePage from "./components/HomePage";

//Admin
import Admin from "./views/Admin";
import Settings from "./views/Settings";

import ImportCSV from "./components/Import.vue";
import UserProfile from "./views/UserProfile.vue";

//Authentication
import Authentication from "./views/Authentication.vue";
import Signup from "./components/auth/Signup.vue";
import Login from "./components/auth/Login.vue";
import NoAccess from "./components/auth/NoAccess.vue";
import EmailVerified from "./components/auth/EmailVerified.vue";
import ResetPassword from "./components/auth/ResetPassword.vue";
import UpdatePassword from "./components/auth/UpdatePassword.vue";
import SendEmail from "./components/auth/SendEmail.vue";


//views
import Analysis from "./views/Analysis.vue";
import Charts from "./views/Dashboard.vue";
import SponsorsReport from "./views/SponsorsReport.vue";
import Filestack from "./views/Filestack.vue";
import ComparisonReport from './views/print/ComparisonReportView.vue';
import ContactForm from './views/ContactForm.vue';

//Print report views
import ViewPrintReport from './views/print/ViewPrintReport.vue';
import ViewFirstGamePrintReport from './views/print/ViewFirstGamePrintReport.vue';
import ViewSecondGamePrintReport from './views/print/ViewSecondGamePrintReport.vue';

const router = new Router({
  mode: 'history',
  routes: [
    // { path: "*", redirect: HomePage },
    {
      path: "/",
      name: "home",
      component: Login
      // component: HomePage
    },
    {
      path: "/video",
      name: "video",
      component: Analysis,
      meta: { requiresAuth: true, requiresUserLevel: 99 }
    },
    {
      path: "/charts",
      name: "charts",
      component: Charts,
      meta: {
        requiresAuth: true,
        requiresUserLevel: 50
      }
    },
    {
      path: "/sponsorsreport",
      name: "sponsorsreport",
      component: SponsorsReport,
      meta: {
        requiresAuth: true,
        requiresUserLevel: 10
      }
    },
    {
      path: "/comparisonreport",
      name: "comparisonreport",
      component: ComparisonReport,
      meta: {
        requiresAuth: true,
        requiresUserLevel: 10
      }
    },
    {
      path: "/viewprintreport",
      name: "viewprintreport",
      component: ViewPrintReport,
      meta: {
        requiresAuth: true,
        requiresUserLevel: 10
      }
    },
    {
      path: "/viewfirstgameprintreport",
      name: "viewfirstgameprintreport",
      component: ViewFirstGamePrintReport,
      meta: {
        requiresAuth: true,
        requiresUserLevel: 10
      }
    },
    {
      path: "/viewsecondgameprintreport",
      name: "viewsecondgameprintreport",
      component: ViewSecondGamePrintReport,
      meta: {
        requiresAuth: true,
        requiresUserLevel: 10
      }
    },
    {
      path: "/filestack",
      name: "filestack",
      component: Filestack,
      meta: {
        requiresAuth: true,
        requiresUserLevel: 100
      }
    },
    {
      path: "/admin",
      name: "admin",
      component: Admin,
      meta: {
        requiresAuth: true,
        requiresUserLevel: 100
      }
    },
    {
      path: "/contact",
      name: "contact",
      component: ContactForm,
      meta: {
        requiresAuth: true,
        requiresUserLevel: 100
      }
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      meta: {
        requiresAuth: true,
        requiresUserLevel: 50
      }
    },
    {
      path: "/importCSV",
      name: "importCSV",
      component: ImportCSV
    },
    {
      path: "/user-profile",
      name: "user-profile",
      component: UserProfile,
      meta: {
        requiresAuth: true,
        requiresUserLevel: 10
      }
    },
    {
      path: "/authentication",
      name: "authentication",
      component: Authentication,
      children: [
        {
          path: "signup",
          name: "signup",
          component: Signup
        },
        {
          path: "login",
          name: "login",
          component: Login
        },
        {
          path: "no-access",
          name: "no-access",
          component: NoAccess
        },
        {
          path: "email-verified",
          name: "email-verified",
          component: EmailVerified
        },
        {
          path: "reset-password",
          name: "reset-password",
          component: ResetPassword
        },
        {
          path: "update-password",
          name: "update-password",
          component: UpdatePassword
        },
        {
          path: "send-email",
          name: "send-email",
          component: SendEmail
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const user = firebase.auth.currentUser;
    let userLevel = store.state.user.active.userLevel;
    //console.log("UserLevel = " + userLevel);
    //console.log("user " + user);
    //console.log("currentUser = " + JSON.stringify(user, null, 2));
    
    //if (!userLevel || !user) {
    if (!userLevel) {
      next({ path: "/authentication/login" });
    } else {
      let reqUserLevel = to.matched.find(
        record => record.meta.requiresUserLevel
      ).meta.requiresUserLevel;
      //console.log("reqUserLevel  = " + reqUserLevel);

      if (to.meta.requiresUserLevel && userLevel < reqUserLevel) {
        // console.log("Access restricted");
        next({ path: "/authentication/no-access" });
      } else next();
    }
  } else next();
});

//Vue.use(Router);


export default router;
